/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Consumption_Series_DjuInputs */



/**
* | output |
* | --- |
* | "{name} · DD" |
*
* @param {Consumption_Series_DjuInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const consumption_series_dju = /** @type {((inputs: Consumption_Series_DjuInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consumption_Series_DjuInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`${i?.name} · DD`)
	return /** @type {LocalizedString} */ (`${i?.name} · DJU`)
});